const handleFormErrors = (error) => {
  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.errors
  ) {
    const { errors } = error.response.data;
    window.alert(`Error: ${errors[0]}`);
  } else if (error.message) {
    window.alert(`Error: ${error.message}`);
  } else {
    window.alert("Error");
  }
};

export { handleFormErrors };
